<template>
	<device-widget
		:status="status"
		:sub-status="subStatus"
		:name="name"
		:node="node"
	/>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import k4ModelBase from "@/components/k4model/base";
import DeviceWidget from "../../../shared/DeviceWidget";

export default {
	components: { DeviceWidget },

	extends: k4ModelBase,

	props: {
		node: {
			type: Object,
			required: true,
		},
	},

	computed: {
		...mapGetters({ getEventData: "controller/eventData" }),

		isOpen() {
			return _.get(this.node, "variables.open", false);
		},

		level() {
			return _.get(this.node, "variables.level", null);
		},

		status() {
			if (this.isLight) return (_.isNil(this.level) ? "--" : this.level) + "%";
			else return this.isOpen ? "Open" : "Closed";
		},

		subStatus() {
			let eventPath = this.isOpen ? "/events/opened" : "/events/closed";
			const event = this.getEventData(this.node.path + eventPath) || {};
			const timeAgo = event.timeAgo;
			if (timeAgo) {
				return `${this.isOpen ? "Opened" : "Closed"} (${timeAgo})`;
			}
			return null;
		},

		name() {
			if (this.isMotionDimmer) return "Motion Dimmer";
			else if (this.isMotionSwitch) return "Motion Switch";
			else return "Motion";
		},
	},
};
</script>
